import localforage from 'localforage';
import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

import type { Price } from '../utils/types';
import { calculationService } from '../utils/api/calculationService';

export const usePricesStore = defineStore(
  'prices',
  () => {
    const data = ref<Price[] | null>(null);
    const pricesById = computed<Record<number, Price>>(() => {
      const prices: Record<number, Price> = {};
      data.value?.forEach((price) => {
        prices[price.id] = price;
      });
      return prices;
    });

    async function getPricesFromLocalforage() {
      await localforage.getItem<Price[]>('prices');
    }

    async function fetch() {
      await getPricesFromLocalforage();

      if (!data.value) {
        data.value = await calculationService.getProductPrices();
      }
    }

    function invalidate() {
      data.value = null;

      fetch();
    }

    function getPriceById(id: number) {
      if (!data.value) {
        return null;
      }

      return pricesById.value[id] || null;
    }

    return {
      data,
      fetch,
      invalidate,
      getPriceById,
    };
  },
  {
    // @ts-ignore
    persist: true,
  }
);
